import React from 'react';
import {Box, useTheme} from '@mui/material';

interface MiniTrendLineProps {
  values: number[];
}

const getSparklinePath = (
  values: number[],
  width: number,
  height: number,
  padding = 2,
) => {
  if (values.length === 0) {
    return '';
  }

  const minValue = Math.min(...values);
  const maxValue = Math.max(...values);
  const valueRange = maxValue - minValue || 1;
  const drawableWidth = width - padding * 2;
  const drawableHeight = height - padding * 2;

  return values
    .map((value, index) => {
      const x =
        padding +
        (values.length === 1
          ? 0
          : (index / (values.length - 1)) * drawableWidth);
      const y =
        padding +
        drawableHeight -
        ((value - minValue) / valueRange) * drawableHeight;
      return `${index === 0 ? 'M' : 'L'} ${x} ${y}`;
    })
    .join(' ');
};

const MiniTrendLine: React.FC<MiniTrendLineProps> = ({values}) => {
  const theme = useTheme();
  const width = 140;
  const height = 28;

  if (values.length === 0) {
    return (
      <Box
        sx={{
          height,
          borderBottom: theme => `1px solid ${theme.palette.divider}`,
        }}
      />
    );
  }

  const path = getSparklinePath(values, width, height);

  return (
    <Box
      component="svg"
      viewBox={`0 0 ${width} ${height}`}
      preserveAspectRatio="none"
      sx={{width: '100%', height: `${height}px`, display: 'block'}}>
      <path
        d={path}
        fill="none"
        stroke={theme.palette.primary.main}
        strokeWidth={1.75}
        vectorEffect="non-scaling-stroke"
      />
    </Box>
  );
};

export default MiniTrendLine;
